import React, { useCallback, useContext, useMemo, useRef } from "react";

import "./PasswordPopup.scss";
import { PopupContext } from "./Popup-Context";
import Select from "react-select";

interface DepositPopupProps {
  handleDeposit?: any;
  bankList?: Array<{
    id: number;
    name: string;
  }>;
  setBank?: React.Dispatch<React.SetStateAction<number>>;
  setDescription?:React.Dispatch<React.SetStateAction<string>>;
}

export const DepositPopup: React.FC<DepositPopupProps> = ({
  handleDeposit,
  bankList,
  setBank,
  setDescription
}) => {
  const { closeModal } = useContext(PopupContext);

  const options= useMemo(() => {
    return bankList?.map((item) => {
      return {
        label: item.name,
        value: item.id
      }
    })
  },[bankList])

  return (
    <div className="deposit-page">
      <div className="col-md-12">
        {bankList && bankList?.length > 0 && (
          <div className="form-group mb-3">
            <label className="input-label">Bank Name</label>
            <div className="data-field">
              <Select
                isClearable={true}
                name=""
                form=""
                styles={{
                  control: (base) => ({
                    ...base,
                    fontSize: "12px",
                  }),
                  menu: (base) => ({
                    ...base,
                    fontSize: "12px",
                  }),
                }}
                options={
                  options
                }
                onChange={(e) => {
                  setBank?.(e?.value ?? 0);
                }}
              />
            </div>
          </div>
        )}
      </div>
      <div className="col-md-12">
        <div className="field-block">
          <label className="input-label">Description</label>
          <textarea placeholder="Enter description here" className="input-field text-area-field" onChange={(e)=> setDescription?.(e.target.value)} rows={4}></textarea>
        </div>
    </div>

      <div className="btn-right">
        <div className="d-end">
          <div>
            <button onClick={closeModal} className="light-secondary mr-16">
              Cancel
            </button>
          </div>
          <div>
            <button
              className="main-button"
              onClick={() => {
                handleDeposit?.();
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
